// roof outline on the aerial snapshot: surroundings lightened, outline drawn in orange
export const polyArea = (p) => Math.abs(p.reduce((s, [x, y], i) => { const [u, v] = p[(i + 1) % p.length]; return s + x * v - u * y; }, 0)) / 2;

export function roofMask(src, pts) {
  return new Promise((res) => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement('canvas'); c.width = img.width; c.height = img.height;
      const g = c.getContext('2d');
      g.drawImage(img, 0, 0);
      const path = () => { g.beginPath(); pts.forEach(([x, y], i) => (i ? g.lineTo(x, y) : g.moveTo(x, y))); g.closePath(); };
      g.save(); g.beginPath(); g.rect(0, 0, c.width, c.height); pts.forEach(([x, y], i) => (i ? g.lineTo(x, y) : g.moveTo(x, y))); g.closePath();
      g.fillStyle = 'rgba(255,255,255,0.6)'; g.fill('evenodd'); g.restore();
      path(); g.lineWidth = Math.max(3, c.width / 300); g.strokeStyle = '#ff6a13'; g.lineJoin = 'round'; g.stroke();
      res(c.toDataURL('image/jpeg', 0.9));
    };
    img.onerror = () => res(src);
    img.src = src;
  });
}
